<div nestableForm name="form">
  <div class="creditcardpayment">
    <div>
      @for(card of EPayService.ePay?.xmlPayment?.creditCards?.cards; track card.cardId)
      {
      <span class="creditcard brands">
        <span>
          <img class="cardbrand {{card.cardId}}" src="assets/{{card.cardId}}_logo.png"
               alt="Accepted card brand {{card.type}}"
               />
        </span>
      </span>
      }
    </div>
    @if(IsCardConnect())
    {
    <card-connect [(carddata)]="carddata"></card-connect>
    }
    @if(IsSnapPay())
    {
    <snap-pay [(carddata)]="carddata"></snap-pay>
    }
  </div>
</div>
